"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _core = require("@emotion/core");
var _BaseInput = _interopRequireDefault(require("./BaseInput"));
var _BaseLabel = _interopRequireDefault(require("./BaseLabel"));
var _InputMask = _interopRequireDefault(require("./InputMask"));
var _formatNumber = require("@argo/utils/formatNumber");
var _InputType = require("@argo/utils/inputValidation/InputType");
var _react = _interopRequireWildcard(require("react"));
var StyledInputWithCustomMask = (0, _InputMask["default"])(_BaseInput["default"]);
var getMaskTypeStyledComponent = function getMaskTypeStyledComponent(maskType) {
  if (maskType) {
    return _BaseInput["default"];
  }
  return StyledInputWithCustomMask;
};
var handleChange = function handleChange(value, maskType) {
  if (maskType === _InputType.InputType.Currency) {
    return (0, _formatNumber.handleCurrency)(value);
  } else if (maskType === _InputType.InputType.Mileage) {
    return (0, _formatNumber.handleMileage)(value);
  }
  return value;
};
var OuterInputField = function OuterInputField(BaseComponent) {
  return _react["default"].memo(function (_ref) {
    var id = _ref.id,
      labelText = _ref.labelText,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["id", "labelText"]);
    var customLabelText = props.required ? "".concat(labelText, " *") : labelText;
    var StyledInput = getMaskTypeStyledComponent(props.maskType);
    var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];
    var onChangeHandler = function onChangeHandler(e) {
      setValue(handleChange(e.target.value, props.maskType));
      if (props.onChange) {
        props.onChange(e);
      }
    };
    return (0, _core.jsx)(BaseComponent, props, (0, _core.jsx)(StyledInput, (0, _extends2["default"])({
      id: id
    }, props, {
      placeholder: "\xA0",
      value: value,
      onChange: onChangeHandler
    })), (0, _core.jsx)(_BaseLabel["default"], (0, _extends2["default"])({
      error: props.error ? true : false
    }, props), customLabelText));
  });
};
var _default = OuterInputField;
exports["default"] = _default;